export const getWebsiteTypeOptions = () => {
    return [
        {
            id: "Transactional",
            text: "topsites.table.site.functionality.filter.transactional",
            tooltipText: "topsites.table.site.functionality.filter.transactional.tooltip",
        },
        {
            id: "ContentPublishing",
            text: "topsites.table.site.functionality.filter.news",
            tooltipText: "topsites.table.site.functionality.filter.news.tooltip",
        },
        {
            id: "Unknown",
            text: "topsites.table.site.functionality.filter.other",
            tooltipText: "topsites.table.site.functionality.filter.other.tooltip",
        },
    ];
};
